module.exports = __webpack_public_path__ + "static/img/email.e4742db4.svg";